import React, { useEffect } from "react";
import { LayoutContainer, ContentWrapper } from "../styles/layout";
import Header from "../shared/util/Header";
import { Outlet } from "react-router-dom";
import Breadcrumb from "../shared/util/Breadcrumb";
import Footer from "../shared/util/Footer";
import TenantModal from "../shared/util/TenantModal";
import AddModal from "../modules/ideia/components/AddModal";
import ViewModal from "../modules/ideia/components/ViewModal";
import EditModal from "../modules/ideia/components/EditModal";

function Layout(): JSX.Element {
    return (
        <LayoutContainer>
            <AddModal />
            <ViewModal />
            <EditModal />
            <TenantModal />
            <Header />
            <ContentWrapper>
                <Outlet />
            </ContentWrapper>
            <Footer />
        </LayoutContainer>
    );
}

export default Layout;